import { Component, OnInit } from '@angular/core';
import { BsModalRef } from "ngx-bootstrap/modal";
import { PermissionsService } from 'src/app/services/permissions/permissions.service';

@Component({
  selector: 'app-learn-more-ua-modal',
  templateUrl: './learn-more-ua-modal.component.pug',
  styleUrls: ['./learn-more-ua-modal.component.scss'],
  standalone: false
})
export class LearnMoreUaModalComponent implements OnInit {

  constructor(
    public _bsModalRef: BsModalRef,
    private permissionsService: PermissionsService
  ) { }

  ngOnInit(): void {
  }

  cancel() {
    this._bsModalRef.hide();
  }

}
